import styled from '@emotion/styled';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 8px 24px;
  flex-direction: column;
`;

export const ChannelNameText = styled.div`
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 6px;
  color: ${({ theme }) => theme.colors.neutral[700]};
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.colors.neutral[300]};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.neutral[700]};
  }

  &:focus-within {
    border: 2px solid ${({ theme }) => theme.colors.shopl[300]};
  }
`;

export const Input = styled.input<{ isDark: boolean }>`
  border: none;
  width: 100%;
  padding: 10px 16px;
  color: ${({ theme, isDark }) => (isDark ? theme.colors.neutral[300] : theme.colors.neutral[700])};
  font-size: 14px;
  background: transparent;
  outline: none;

  &::placeholder {
    color: ${({ theme, isDark }) => (isDark ? 'var(--sendbird-dark-ondark-02)' : theme.colors.neutral[350])};
  }

  &:-webkit-autofill {
    box-shadow: 0 0 0 30px white inset !important;
  }
  &:-webkit-autofill:hover {
    box-shadow: 0 0 0 30px white inset !important;
  }
  &:-webkit-autofill:focus {
    box-shadow: 0 0 0 30px white inset !important;
  }
  &:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
  }

  &[type='password']::-ms-reveal,
  &[type='password']::-ms-clear {
    display: none;
  }
`;

export const Guide = styled.div`
  margin-top: 6px;
  font-size: 12px;
  line-height: 18px;
  width: 100%;
  word-break: break-all;
  white-space: pre-line;
  padding-bottom: 20px;
`;
